// extracted by mini-css-extract-plugin
module.exports = {"title":"Account_title__37kWT","wrapper":"Account_wrapper__33OvI"};